export default `## Hallo.

Wir sind [Wagnerwagner](https://www.wagnerwagner.de), eine Werbeagentur mit Schwerpunkt in digitaler Kommunikation.

Wenn andere Agenturen an der Website scheitern, fangen wir erst richtig an.

Für unsere Kunden designen und entwickeln wir Shops, Web-Apps oder IoT-Anwendungen.

![Applaus](https://giphy.com/go/ZTY5MWM4ODAt)
`;
